<template>
  <generic-container
    :title="title"
    icon="list"
    :header_buttons="header_buttons"
  >
    <table
      class="ui celled striped very compact selectable striped table"
      ref="table"
    >
      <thead>
        <tr>
          <!-- <th>{{ $t("id") }}</th> -->
          <th>{{ $t("request date") }}</th>
          <th>{{ $t("response date") }}</th>
          <th>{{ $t("request data") }}</th>
          <th>{{ $t("response data") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <!-- <chart ref="ch" style="width:50%" /> -->
    <template v-for="(mdl, index) in log_modals">
      <component
        :is="mdl"
        :key="index"
        :log_in="selected_log"
        @destroy="destroy"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import {
  local_api,
  init_json_local_data_datables,
  init_ajax_data_datables,
  stringify,
  enterprise_setup,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { truncate } from "lodash";
import LogModal from "@/modules/api_manager/log_modal/Index";
import "datatables.net";
import "datatables.net-se";
import Chart from "./Chart";

// @ is an alias to /src
export default {
  name: "Monitor",
  components: {
    "generic-container": GenericContainer,
    Chart,
  },
  filters: filters,
  props: {
    // endpoint: Object,
  },
  data() {
    return {
      requests: [],
      table: undefined,
      log_modals: [],
      selected_log: {},
      endpoint: {},
      header_buttons: [
        {
          icon: "red remove",
          click: this.hide_monitor,
        },
      ],
    };
  },
  computed: {
    title() {
      if (this.endpoint) {
        return this.endpoint.name + " monitor";
      } else return "pick one";
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    update_endpoint_info(endpoint) {
      if (this.table) {
        this.table.destroy();
      }
      if (endpoint && endpoint.uuid) {
        let vm = this;
        local_api(this, "post", "/api_manager/do-get-info", {
          i: endpoint.uuid,
        })
          .then((list) => {
            // let data = endpt.api_logs.map((l) => {
            //   l.request_data = JSON.parse(l.request_data);
            //   l.response_data = JSON.parse(l.response_data);
            //   return l;
            // });
            let data = list.map((l) => {
              l.request_data = JSON.parse(l.request_data);
              l.response_data = JSON.parse(l.response_data);
              return l;
            });

            // let ent_setup = enterprise_setup(vm);

            let columns = [
              {
                data: function(row) {
                  return row.log_id;
                },
              },
              {
                data: function(row) {
                  return filters.formatDate(
                    row.request_date,
                    enterprise_setup.second_detailed_date_format,
                  );
                },
              },
              {
                data: function(row) {
                  return row.response_date
                    ? filters.formatDate(
                        row.response_date,
                        enterprise_setup.second_detailed_date_format,
                      )
                    : `-- ${vm.$t("pending")} --`;
                },
              },
              {
                data: function(row) {
                  return truncate(JSON.stringify(row.request_data), {
                    length: 55,
                  });
                },
              },
              {
                data: function(row) {
                  return truncate(JSON.stringify(row.response_data), {
                    length: 55,
                  });
                },
              },
            ];

            init_json_local_data_datables(
              vm,
              vm.$refs.table,
              data,
              columns,
              (row) => {
                vm.selected_log = row;
                vm.log_modals.push(LogModal);
              },
              null,
            );
          })
          .catch((err) => {
            vm.$alertify.error(stringify(err));
          });
      }
    },
    destroy() {
      this.selected_log = {};
      this.log_modals = [];
    },
    refresh() {
      if (this.endpoint) this.update_endpoint_info(this.endpoint);
    },
    init_table(endpoint) {
      let vm = this;
      let endpoint_uuid = endpoint.uuid;
      // console.log("initing table for endpoint", endpoint_uuid);
      this.endpoint = endpoint;
      if (endpoint_uuid) {
        if (vm.table) {
          vm.table.destroy();
        }

        let columns = [
          // {
          //   data: function(row) {
          //     return row.log_id;
          //   },
          // },
          {
            data: function(row) {
              return filters.formatDate(
                row.request_date,
                vm.enterprise_setup.second_detailed_date_format,
              );
            },
          },
          {
            data: function(row) {
              return row.response_date
                ? filters.formatDate(
                    row.response_date,
                    vm.enterprise_setup.second_detailed_date_format,
                  )
                : `-- ${vm.$t("pending")} --`;
            },
          },
          {
            data: function(row) {
              return truncate(JSON.stringify(row.request_data), {
                length: 55,
              });
            },
          },
          {
            data: function(row) {
              return truncate(JSON.stringify(row.response_data), {
                length: 55,
              });
            },
          },
        ];
        let onSelect = (data) => {
          vm.selected_log = data;
          vm.log_modals.push(LogModal);
        };
        let onCreatedRow = (/* a */) => {
          // console.log(a)
        };
        let requestTransform = (data) => {
          data.search.endpoint_uuid = endpoint_uuid;
        };
        vm.table = init_ajax_data_datables(
          vm,
          vm.$refs.table,
          window.jQuery.fn.api.settings.api["api manager endpoint monitor url"],
          columns,
          onSelect,
          onCreatedRow,
          requestTransform,
        );
      }
    },
    hide_monitor() {
      this.$emit("hide_monitor");
    },
  },
  mounted() {
    if (this.endpoint) this.update_endpoint_info(this.endpoint);
  },
  watch: {
    // endpoint() {
    //   if (this.endpoint) this.update_endpoint_info(this.endpoint);
    // },
  },
};
</script>
